<template>
  <form>
    <div class="settings-top-bar" ref="optionsTopBar">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="$route.params.id" @click.prevent="deleteOrderScreen" style="padding: 7px 10px; margin-right: 20px;">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15 mar-bt-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-6 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg><!---->
            </div>
          </div>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{$t('settingTable.location')}}</label>
                  <select
                    name="location"
                    class="form-control"
                    v-validate="modelValidate.location_token"
                    v-model="model.location_token"
                    @change="updateLocationId($event)"
                  >
                    <option value="null">{{$t('general.all')}}</option>
                    <option
                      v-for="(loc) in locations"
                      :value="loc.token"
                      :label="loc.name"
                      :key="loc.id">
                    </option>
                  </select>
                  <small class="text-danger" v-show="type.invalid">
                    {{ getError('type') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingTable.type')}}</label>
                  <select
                    name="type"
                    class="form-control"
                    v-validate="modelValidate.type"
                    v-model="model.type"
                  >
                    <option
                      v-for="typ in type"
                      :disabled="model.location_token == 'null' && typ == 'Client'"
                      :value="typ"
                      :label="$t('orderScreen.type'+typ)"
                      :key="typ">
                    </option>
                  </select>
                  <small class="text-danger" v-show="type.invalid">
                    {{ getError('type') }}
                  </small>
                  <i class="fa fa-info-circle mar-to-10" aria-hidden="true"></i>{{ $t('orderScreen.selectLocation') }}
                </div>

                <div class="form-group">
                  <label>{{$t('kds.section')}}</label>
                  <select
                    name="type"
                    class="form-control"
                    v-model="model.kds_section_id"
                  >
                    <option :value="null" :label="$t('general.all')"> </option>
                    <option
                      v-for="section in kdsSections"
                      :value="section.id"
                      :label="section.name"
                      :key="section.id">
                    </option>
                  </select>
                </div>

                <div class="form-group" v-if="model.type === 'Client'">
                  <label>{{$t('orderScreen.excludeSections')}}</label>
                  <el-select
                    v-model="model.excluded_kds_section_ids"
                    multiple
                    filterable
                    :disabled="!!model.kds_section_id"
                    style="width: 100%;"
                    :placeholder="$t('general.select')">
                    <el-option
                      v-for="section in kdsSections"
                      :key="section.id"
                      :label="section.name"
                      :value="section.id">
                    </el-option>
                  </el-select>
                </div>

                <div class="form-group">
                  <!-- <label>{{$t('settingTable.type')}}</label> -->
                  <label>Limba</label>
                  <select
                    name="type" class="form-control"
                    v-model="model.language"
                  >
                    <option
                      v-for="lang in languages"
                      :value="lang.id"
                      :label="lang.label"
                      :key="lang.id">
                    </option>
                  </select>
                  <small class="text-danger" v-show="type.invalid">
                    {{ getError('type') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.type == 'Kitchen'">
                  <p-checkbox
                    v-model="model.print_order"
                  >{{$t('settingTable.printOrder')}}</p-checkbox>
                </div>
                <div class="form-group" v-if="model.type == 'Client'">
                  <p-checkbox
                    v-model="model.include_table_orders"
                  >{{$t('orderScreen.includeTableOrders')}}</p-checkbox>
                </div>
                <div class="form-group" v-if="model.type == 'Client'">
                  <p-checkbox
                    v-model="model.ods_offline"
                  >{{$t('orderScreen.odsOffline')}}</p-checkbox>
                  <input v-if="model.ods_offline"
                         type="text"
                         name="ip_server"
                         data-vv-as="IP Server"
                         :placeholder="$t('orderScreen.ipServer')"
                         v-validate="'required'"
                         v-model="model.ip_server"
                         class="form-control mar-to-10">
                  <small class="text-danger" v-show="errors.has('ip_server')">
                    {{ getError('ip_server') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.type == 'Client'">
                  <label>{{$t('orderScreen.posIds')}}</label>
                  <el-select
                    v-model="model.pos_ids"
                    multiple
                    collapse-tags
                    filterable
                    style="width: 100%; height: auto; min-height: 40px;"
                    :placeholder="$t('general.select')">
                    <el-option
                      v-for="item in allPoses"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <div class="form-group" v-if="model.type == 'Kitchen' && model.id">
                  <label>{{$t('settingTable.without_OrderFormFlags')}}</label>
                  <v-select v-model="model.no_orders_selected_order_flags"
                    multiple
                    :options="getOrderFormFlags()"
                    value=""
                    label=""
                    :ref="'name'"
                    :placeholder="$t('general.all')"
                    class=""
                    :key="'name'">
                    </v-select>
                </div>
                <div class="form-group" v-if="model.type == 'Kitchen' && model.id">
                  <p-checkbox
                    v-model="model.use_fiscal_net"
                  >{{$t('settingTable.use_fiscal_net')}}</p-checkbox>
                  <input  v-if="model.use_fiscal_net"
                          type="text"
                          name="ip"
                          data-vv-as="ip"
                          placeholder="IP"
                          v-model="model.fiscal_ip"
                          class="form-control">
                </div>
              </div>
            </div>
            <div class="row" v-if="model.type == 'Client'">
              <div class="col-md-6">
                <BackgroundColorPicker :title="$t('orderScreen.odsBackgroundColor')" :palette="'odsColors'" :color="model.ods_background_color" @color-change="updateColor($event, 'ods_background_color')" ></BackgroundColorPicker>
              </div>
            </div>
            <div class="row" v-if="model.type == 'Client'">
              <div class="col-md-6">
                <BackgroundColorPicker :title="$t('orderScreen.odsHeaderTextColor')" :palette="'odsColors'" :color="model.ods_header_text_color" @color-change="updateColor($event, 'ods_header_text_color')" ></BackgroundColorPicker>
              </div>
              <div class="col-md-6">
                <BackgroundColorPicker :title="$t('orderScreen.odsBodyTextColor')" :palette="'odsColors'" :color="model.ods_body_text_color" @color-change="updateColor($event, 'ods_body_text_color')" ></BackgroundColorPicker>
              </div>
            </div>
            <div class="row" v-if="model.type == 'Client'">
              <div class="col-md-4">
                <BackgroundColorPicker :title="$t('orderScreen.odsStatus1Color')" :palette="'odsColors'" :color="model.ods_status_1_color" @color-change="updateColor($event, 'ods_status_1_color')" ></BackgroundColorPicker>
              </div>
              <div class="col-md-4">
                <BackgroundColorPicker :title="$t('orderScreen.odsStatus2Color')" :palette="'odsColors'" :color="model.ods_status_2_color" @color-change="updateColor($event, 'ods_status_2_color')" ></BackgroundColorPicker>
              </div>
              <div class="col-md-4">
                <BackgroundColorPicker :title="$t('orderScreen.odsStatus3Color')" :palette="'odsColors'" :color="model.ods_status_3_color" @color-change="updateColor($event, 'ods_status_3_color')" ></BackgroundColorPicker>
              </div>
            </div>
            <div class="row" v-if="model.type == 'Client'">
              <div class="col-md-6 form-group">
                <label>{{$t('orderScreen.odsColumn1TextLanguage1')}}</label>
                <input type="text" placeholder="In preparare" v-model="model.ods_column_1_text_language_1" name="odsColumn1TextLanguage1" class="form-control">
              </div>
              <div class="col-md-6 form-group">
                <label>{{$t('orderScreen.odsColumn2TextLanguage1')}}</label>
                <input type="text" placeholder="Gata" v-model="model.ods_column_2_text_language_1" name="odsColumn1TextLanguage2" class="form-control">
              </div>
            </div>
            <div class="row" v-if="model.type == 'Client'">
              <div class="col-md-6 form-group">
                <label>{{$t('orderScreen.odsColumn1TextLanguage2')}}</label>
                <input type="text" placeholder="Preparing" v-model="model.ods_column_1_text_language_2" name="odsColumn2TextLanguage1" class="form-control">
              </div>
              <div class="col-md-6 form-group">
                <label>{{$t('orderScreen.odsColumn2TextLanguage2')}}</label>
                <input type="text" placeholder="Ready" v-model="model.ods_column_2_text_language_2" name="odsColumn2TextLanguage2" class="form-control">
              </div>
            </div>
            <div class="row" v-if="model.type == 'Client'">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('upload.browse') }}</label>
                  <el-upload
                    action=""
                    ref="upload"
                    :limit="1"
                    :file-list="model.imagelist"
                    list-type="picture-card"
                    accept=" .jpg, .jpeg, .png"
                    :on-change="handleImgChnage"
                    :on-exceed="handleExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false">
                    <i class="el-icon-plus"></i>
                    <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize2MB')}}</div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12" v-if="model.id">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div class="card-content" style="height:100%; width:100%; margin: 0; display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: center;">
            <div class="row" v-if="model.ods_offline">
              <div class="col-lg-4 col-md-6">
                <p style="margin: 0; min-width: 110px;">{{$t('orderScreen.odsCode')}}</p>
              </div>
              <div class="col-lg-8 col-md-6">
                <div class="row">
                  <div class="col-md-10">
                    <input style="margin: 0;" class="copy_link" type="text" @click="copyToClipboard(odsCode)" disabled=true :value="odsCode">
                  </div>
                  <div class="col-md-2">
                    <a
                      class="btn btn-icon btn-info"
                      :title="$t('general.copyToClipboard')"
                      style="padding: 6px 5px;"
                      @click="copyToClipboard(odsCode)">
                      <i class="fa fa-copy"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="!model.ods_offline">
              <div class="col-lg-4 col-md-6">
                <!-- <p style="margin: 0; min-width: 110px;">{{$t('settingTable.loginCode')}}</p> -->
                <p style="margin: 0; min-width: 110px;">URL</p>
              </div>
              <div class="col-lg-8 col-md-6">
                <div class="row">
                  <div class="col-md-10">
                    <input style="margin: 0;" class="copy_link" type="text" @click="copyToClipboard(model.url)" disabled=true :value="model.url">
                  </div>
                  <div class="col-md-2">
                    <a
                      class="btn btn-icon btn-info"
                      :title="$t('general.copyToClipboard')"
                      style="padding: 6px 5px;"
                      @click="copyToClipboard(model.url)">
                      <i class="fa fa-copy"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 15px" v-if="!model.ods_offline">
              <div class="col-lg-4 col-md-6">
                <p style="margin: 0; min-width: 110px;">{{$t('settingTable.loginCode')}}</p>
              </div>
              <div class="col-lg-8 col-md-6">
                <div class="row">
                  <div class="col-md-10">
                    <input style="margin: 0;" class="copy_link" type="text" @click="copyToClipboard(model.login_code)" disabled=true :value="model.login_code">
                  </div>
                  <div class="col-md-2">
                    <a
                      class="btn btn-icon btn-info mar-rt-10"
                      :title="$t('general.copyToClipboard')"
                      style="padding: 6px 5px;"
                      @click="copyToClipboard(model.login_code)">
                      <i class="fa fa-copy"></i>
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker, Select, Option} from 'element-ui'
  import BackgroundColorPicker from 'src/components/UIComponents/BackgroundColorPicker.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      [Button.name]: Button,
      BackgroundColorPicker,
      [Input.name]: Input,
      [Select.name]: Select,
      [Option.name]: Option
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getKdsSections()
      this.getPoses()
      this.getData()
    },
    data () {
      return {
        apiUrl: '',
        roles: [],
        kdsSections: [],
        allPoses: [],
        id: this.value || this.tableId,
        isNew: true,
        filelist: [],
        model: {
          'id': 0,
          'location_token': '',
          'location_id': '',
          'type': 'Client',
          'include_table_orders': 0,
          'pos_ids': [],
          'kds_section_id': null,
          'excluded_kds_section_ids': [],
          'ods_offline': 0,
          'ip_server': null
        },
        type: ['Kitchen', 'Client'],
        locations: [],
        modelValidate: {
          type: {required: true}
        },
        languages: [{'id': 'ro', 'label': 'Romana'}, {'id': 'en', 'label': 'English'}, {'id': 'es', 'label': 'Espagnol'}, {'id': 'gr', 'label': 'Greek'}, {'id': 'cz', 'label': 'Czech'}],
        loading: true
      }
    },
    computed: {
      odsCode () {
        return this.$session.get('selectedCompany') + '.' + this.model.id
      }
    },
    watch: {
      'model.kds_section_id' (sectionId) {
        if (sectionId) this.model.excluded_kds_section_ids = []
      },
      'model.type' (newType) {
        // When the type changes, the offline checkbox and its IP disappear.
        if (newType !== 'Client') {
          this.model.excluded_kds_section_ids = []
          this.model.ods_offline = 0
          this.model.ip_server = null
        }
      }
    },
    methods: {
      getPoses () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/pos', 'GET', data, (response) => {
          if (response.status === true && response.data && response.data.pos) {
            this.allPoses = response.data.pos
          }
        })
      },
      normalizePosIds (posIds) {
        if (!posIds) return []
        if (typeof posIds === 'string') {
          return posIds.split(',').map(id => parseInt(id, 10)).filter(id => !isNaN(id))
        }
        if (!Array.isArray(posIds)) return []
        return posIds.map(item => {
          if (item && typeof item === 'object') return item.id
          return parseInt(item, 10)
        }).filter(id => id != null && !isNaN(id))
      },
      getKdsSections () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/kds-sections', 'GET', data, (response) => {
          if (response.status === true) {
            this.kdsSections = response.data

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      updateColor (value, attribute) {
        this.model[attribute] = value
      },
      handleImgChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }

        if (this.model.imagelist && this.model.imagelist[0].status === 'ready') {
          this.getBase64(this.model.imagelist[0].raw).then(
            (base64enc) => {
              this.model.ods_multimedia = base64enc
            }
          )
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
          this.model.ods_multimedia = null
        }
      },
      handleExceed (files, fileList) {
        swal({
          text: 'Please remove the current file in order to be able to add a new one',
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
        return isOkSize
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy)
      },
      getData () {
        this.locations = []
        let requestData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        let id = this.route.params.id
        if (id) {
          this.apiRequest('/order-screen/' + id, 'GET', requestData, (response) => {
            if (response.status) {
              response.data.excluded_kds_section_ids = this.normalizePosIds(response.data.excluded_kds_section_ids)
              this.model = response.data
              this.model.pos_ids = this.normalizePosIds(response.data.pos_ids)
              if (response.data.ods_multimedia) {
                this.model.imagelist = [{url: response.data.ods_multimedia}]
              } else {
                this.model.imagelist = []
              }
            }
          })
        }

        this.apiRequest('/get-locations', 'GET', requestData, (response) => {
          if (response.status) {
            this.locations = response.data
          }
        })
        this.$nextTick(() => { this.loading = false })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveTable() }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      saveTable () {
        this.$nextTick(() => { this.loading = true })
        let data = this.model
        data.excluded_kds_section_ids = data.type === 'Client' && !data.kds_section_id
          ? this.normalizePosIds(data.excluded_kds_section_ids) : []
        if (!data.print_order) {
          data.print_order = 0
        }
        if (!data.include_table_orders) {
          data.include_table_orders = 0
        }
        if (data.type === 'Client') {
          data.pos_ids = this.normalizePosIds(data.pos_ids)
        } else {
          data.pos_ids = []
        }
        if (data.type !== 'Client' || !data.ods_offline) {
          data.ods_offline = 0
          data.ip_server = null
        } else {
          data.ods_offline = 1
        }
        var companyID = this.$session.get('selectedCompany')
        data.token = this.$session.get('token')
        data.company_id = companyID

        var id = this.id || this.route.params.id
        let url = ''
        let request = ''
        if (id) {
          url = '/order-screen/' + id
          request = 'PUT'
        } else {
          url = '/order-screen/'
          request = 'POST'
        }
        this.apiRequest(url, request, data, (response) => {
          if (response.status === true) {
            this.$nextTick(() => { this.loading = false })
            this.errors.clear()
            if (request === 'POST') {
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              // this.router.push('/order-screen/edit/' + response.data.id)
            } else {
              this.backButton()
            }
            swal(
              {
                title: '',
                text: this.$t('settingTable.tableSave'),
                type: 'success',
                showConfirmButton: false,
                timer: 1500
              }
            )
          } else {
            this.$nextTick(() => { this.loading = false })
            this.handleErrors(response.errors)
          }
        })
      },
      deleteOrderScreen () {
        this.$nextTick(() => { this.loadingReset = true })
        var id = this.id || this.route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/order-screen/' + id, 'DELETE', data, (response) => {
          if (response.status) {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': 'Saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      backButton () {
        this.$session.set('selectedTab', this.$t('pages.orderScreen'))
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push('/screens/tabs?tabIndex=0')
      },
      updateLocationId (event) {
        if (event.target.value !== 'null') {
          const selectedLocation = this.locations.find(item => item.token === event.target.value)
          this.model.location_id = selectedLocation.id
        } else {
          this.model.type = 'Kitchen'
        }
      }
    }
  }
</script>
<style>
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/OrderScreen/OrderScreenForm.vue